/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Placements_Deal_Highlight_DescriptionInputs */

const en_directory_promotion_placements_deal_highlight_description = /** @type {(inputs: Directory_Promotion_Placements_Deal_Highlight_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show a time-bound offer in the deals discovery surface.`)
};

const zh_directory_promotion_placements_deal_highlight_description = /** @type {(inputs: Directory_Promotion_Placements_Deal_Highlight_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在优惠发现区域展示限时活动。`)
};

/**
* | output |
* | --- |
* | "Show a time-bound offer in the deals discovery surface." |
*
* @param {Directory_Promotion_Placements_Deal_Highlight_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_placements_deal_highlight_description = /** @type {((inputs?: Directory_Promotion_Placements_Deal_Highlight_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Placements_Deal_Highlight_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_placements_deal_highlight_description(inputs)
	return zh_directory_promotion_placements_deal_highlight_description(inputs)
});
export { directory_promotion_placements_deal_highlight_description as "directory.promotion.placements.deal-highlight.description" }